import FixScroll  from '../helpers/FixScroll'

class Menu {
  constructor(el) {
    this.el = el
    this.isOpen = false
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.updateHeight()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$navigation = this.el.querySelector('.js-navigation')
    this.ui.$toggleButton = this.el.querySelector('.js-navigation-toggle')
    this.ui.$openBtn = this.el.querySelector('.js-navigation-open')
    this.ui.$closeBtn = this.el.querySelector('.js-navigation-close')
    this.ui.$icon = this.ui.$toggleButton.querySelector('.icon')
    this.lastScroll = 0
    this.headerHeight = document.querySelector('.js-header')
    this.headerPos = this.el.getBoundingClientRect()
  }

  updateHeight() {
    this.headerHeight = document.querySelector('.js-header')
    document.documentElement.style.setProperty('--header-height', `${this.headerHeight.offsetHeight}px`)
  }
  

  bindEvents() {
    this.ui.$toggleButton.addEventListener('click', this.toggle.bind(this))
    window.addEventListener('scroll', this.onScroll.bind(this))
    document.addEventListener('keydown', this.onKeyDown.bind(this))
  }

  onScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop

    if (currentScroll > this.headerPos.bottom && this.lastScroll <= currentScroll){
      this.lastScroll = currentScroll;
      this.el.classList.add('is-not-visible') 
    } else {
      this.lastScroll = currentScroll;
      this.el.classList.remove('is-not-visible') 
    }
  }

  onKeyDown(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.onClose()
      this.setAriaDescribedBy()
    }
  }

  toggle() {
    if(!this.isOpen) {
      this.onOpen()
    } else {
      this.onClose()
    }
    this.setAriaDescribedBy()
  }
  setAriaDescribedBy() {
    this.ui.$toggleButton.setAttribute('aria-describedby', this.isOpen ? 'close-menu' : 'open-menu')
  }
  onOpen() {
    FixScroll.fix()
    document.body.classList.add('menu-is-open')
    this.ui.$openBtn.classList.add('u-is-hidden')
    this.ui.$closeBtn.classList.remove('u-is-hidden')
    this.isOpen = true
    this.trapFocus(this.headerHeight)
    
  }
  trapFocus(container) {
    if (this.focusHandler) {
        this.currentContainer.removeEventListener('keydown', this.focusHandler);
    }

    this.currentContainer = container;
    this.focusHandler = (e) => {
        const focusableElements = container.querySelectorAll('button, select, [aria-expanded="true"] a,a.button');
        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            } else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        }
    };

    this.currentContainer.addEventListener('keydown', this.focusHandler);
}


  onClose() {
    FixScroll.unFix()
    document.body.classList.remove('menu-is-open')
    this.ui.$openBtn.classList.remove('u-is-hidden')
    this.ui.$closeBtn.classList.add('u-is-hidden')
    this.isOpen = false

    let subItems = this.el.querySelectorAll('.js-nav-item')
    for (let i = 0; i < subItems.length; i++) {
      const target = subItems[i]
      window.collapsible[0].close(target)
    }
  }
}

export default Menu
